import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { TagIcon } from '@gemini/icons';
const PropertiesForSale = ({ propertiesCount, content, fontSize = '14', iconSize = 'sizing.16', }) => {
    const hasProperties = propertiesCount && propertiesCount > 0;
    let placeHolder;
    if (hasProperties) {
        placeHolder = content.properties;
    }
    else {
        placeHolder = content.noProperties;
    }
    return (_jsxs(Box, { alignItems: "center", color: hasProperties ? 'color.content.default.default' : 'color.content.disabled', display: "flex", children: [_jsx(TagIcon, { marginRight: "spacing.6", size: iconSize }), _jsx(Box, { as: "span", typography: `typography.body.${fontSize}.regular`, children: placeHolder })] }));
};
export default PropertiesForSale;
